module.exports = __webpack_public_path__ + "img/applicationConstruction-3d.1844d0a7.png";